<template>
  <v-select
    v-model="selectedItem"
    :items="items"
    :label="label"
    item-text="name"
    item-value="id"
    item-color="secondary"
    color="secondary"
    @change="select"
    hide-details
    single-line
    outlined
    dense
  >
    <template v-slot:prepend-item v-if="search" >
      <v-list-item>
        <v-text-field v-model="keyword" placeholder="Search" hide-details></v-text-field>
      </v-list-item>
    </template>
    <template v-slot:selection="{ item }">
      {{ item.name }}
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SingleSelectFilter',
  props: {
    items: Array,
    label: String,
    filterKey: String,
    selected: Array,
    search: Boolean,
  },
  data() {
    return {
      selectedItem: '',
      keyword: ""
    }
  },
  methods: {
    select(e) {
      this.$emit('select', this.selectedItem ? [this.selectedItem] : [], this.filterKey, this.items)
    },
  },
  watch: {
    selected: {
      handler: function(val) {
        if (!val || val.length == 0) {
          this.selectedItem = ''
        } else {
          this.selectedItem = this.selected[0]
        }
      },
      deep: true
    }
  },
  mounted() {
    if (!this.selected || this.selected.length == 0) {
      this.selectedItem = ''
    } else {
      this.selectedItem = this.selected[0]
    }
  }
}
</script>

<style lang="scss" scoped>
// ::v-deep .v-select__selections {
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: block;

//   input {
//     width: 10px;
//   }
// }

// ::v-deep .v-list-item__action {
//   margin-right: 10px!important;
// }
</style>